(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bshop-hero-slides"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bshop-hero-carousel')) {
    customElements.define('bshop-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-carousel-enabled')) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        // Pestaña extra (Cyber Day): el bloque la dibuja dentro de un contenedor oculto; acá se acomoda con las demás.
        const extraTab = this.querySelector('[data-cyber-tab]');
        const extraSlide = extraTab?.querySelector('[data-promo-slide]');
        const extraDot = extraTab?.querySelector('[data-cyber-dot]');
        const controls = this.querySelector('.bshop-hero-controls');
        if (extraSlide && extraDot && controls) {
          this.insertBefore(extraSlide, controls);
          controls.insertBefore(extraDot, controls.querySelector('[data-carousel-pause]'));
        }
        this.slides = [this.querySelector('.hero__container'), ...this.querySelectorAll('[data-promo-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-index]')];
        this.index = 0;
        this.inView = true;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.focusPaused = false;
        this.pauseControl = this.querySelector('[data-carousel-pause]');
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i), options));
        this.pauseControl.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
        this.addEventListener('focusin', event => { if (!event.target.closest('.bshop-hero-controls')) { this.focusPaused = true; this.schedule(); } }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget) || event.relatedTarget?.closest('.bshop-hero-controls')) { this.focusPaused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => { this.syncVideo(); this.schedule(); }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('.bshop-hero-controls')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show((this.index + (event.key === 'ArrowRight' ? 1 : this.slides.length - 1)) % this.slides.length);
            this.dots[this.index].focus();
          }
        }, options);
        this.updatePause();
        this.show(0);
        this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.syncVideo(); this.schedule(); });
        this.observer.observe(this);
      }
      updatePause() {
        this.pauseControl.setAttribute('aria-label', this.paused ? this.pauseControl.dataset.playLabel : this.pauseControl.dataset.pauseLabel);
        this.pauseControl.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        this.pauseControl.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
      }
      show(index) {
        this.index = index;
        this.dataset.activeSlide = String(index);
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
          this.dots[i].setAttribute('aria-pressed', String(i === index));
        });
        this.syncVideo();
        this.schedule();
      }
      syncVideo() {
        this.slides[0].querySelectorAll('video').forEach(video => {
          if (this.index === 0 && this.inView && !document.hidden) video.play()?.catch(() => {});
          else video.pause();
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.focusPaused && this.inView && !document.hidden) this.timer = setTimeout(() => this.show((this.index + 1) % this.slides.length), 5000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    /* Atajo de teclado: la tecla barra abre la busqueda (patron habitual en tiendas premium) */
  document.addEventListener('keydown', (event) => {
    if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return;
    const target = event.target;
    if (target instanceof HTMLElement && (target.isContentEditable || target.closest('input, textarea, select'))) return;
    const trigger = document.querySelector('[data-bshop-search-trigger]');
    if (!trigger || trigger.offsetParent === null) return;
    event.preventDefault();
    trigger.click();
  });
  } catch(e) { console.error(e); }
})();

})();
